import React from 'react'
import { Routes, Route } from 'react-router-dom';
import Book from './Book';
import Demo from './Demo';
import Hocbong from './Hocbong';

export default function Router({objectProp}) {
  return (
    <Routes>
        <Route path="/" element={<Book objectProp={objectProp}/>} />
        <Route path="/demo" element={<Demo objectProp={objectProp}/>} />
        <Route path="/hocbong" element={<Hocbong objectProp={objectProp}/>} />

        <Route path="*" element={<></>} />
    </Routes>
  )
}
